import React, { useCallback, useState, useEffect } from 'react';
import { CreateReport, PrestationForm } from '../../../components';
import { useApi } from '../../../hooks';
import { paths } from '../../../routes';
import * as Yup from 'yup';

let selectedServiceName = '';

const serviceNameWithFirstRoulement = [
  4073, 4071, 5760, 4085, 4080, 4068
];

export const NecForms: React.FC = () => {
  const { getAgentNecByService } = useApi();
  const [necState, setNecState] = useState(true);
  const [disableFirstRoulement, setDisableFirstRoulement] = useState(false);

  const handleOnChange = useCallback(
    async (form) => {
      const serviceName = form?.values?.serviceName;
      const nec = form?.values?.fieldReportsDto?.nec?.necPresence;

      const { setFieldValue } = form;

      if (nec !== necState) {
        setNecState((state) => {
          if (state) {
            setFieldValue('fieldReportsDto.nec.nbrPresent', 0);
          }
          return nec;
        });
      }

      try {
        if (serviceName !== selectedServiceName) {
          selectedServiceName = serviceName;
          const disableFirstRoulement =
            !serviceName || !serviceNameWithFirstRoulement.includes(parseInt(selectedServiceName));

          setDisableFirstRoulement(disableFirstRoulement);

          const [response]: any = await getAgentNecByService(serviceName);
          form.setFieldValue('fieldReportsDto.nec.cleanerTheoreticalNbr', response.nbrNEC);
        }
      } catch (error) {}
    },
    [getAgentNecByService, necState]
  );

  useEffect(
    () => () => {
      selectedServiceName = '';
    },
    []
  );

  return (
    <>
      {console.log('</>', disableFirstRoulement)}
    <CreateReport
      themeShortCode={paths.proprete.themeShortCode || ''}
      initialValues={{
        fieldReportsDto: {
          exteriorCleanliness: {
            qualityService: {
              motif: [],
            },
          },
          nec: {
            necPresence: true,
            qualityService: { isCompliant: undefined, motif: [] },
            cleanerTheoreticalNbr: 0,
          },
          interiorCleanliness: { qualityService: { motif: [] } },
        },
      }}
      otherFields={{
        section1: {
          type: 'section',
          label: 'PROPRETÉ INTÉRIEUR (1ER ROULEMENT DE LA RAME)',
          name: 'section',
        },
        interiorCleanlinessQuality: {
          label: '',
          type: 'custom',
          component: (
            <PrestationForm
              disabled={disableFirstRoulement}
              compliantName="fieldReportsDto.interiorCleanliness.qualityService.isCompliant"
              motifName="fieldReportsDto.interiorCleanliness.qualityService.motif"
              commentName="fieldReportsDto.interiorCleanliness.qualityService.comments"
              motifOptions={[
                {
                  value: 'WC',
                  label: 'WC',
                },
                {
                  value: 'Présence de détritus',
                  label: 'Présence de détritus',
                },
                {
                  value: 'Tâches non nettoyées',
                  label: 'Tâches non nettoyées',
                },
                {
                  value: 'Autres',
                  label: 'Autres',
                },
              ]}
            />
          ),
        },
        section2: {
          type: 'section',
          label: 'PROPRETÉ EXTÉRIEUR (1ER ROULEMENT DE LA RAME)',
          name: 'section',
        },
        exteriorCleanlinessQuality: {
          label: '',
          type: 'custom',
          component: (
            <PrestationForm
              disabled={disableFirstRoulement}
              compliantName="fieldReportsDto.exteriorCleanliness.qualityService.isCompliant"
              motifName="fieldReportsDto.exteriorCleanliness.qualityService.motif"
              commentName="fieldReportsDto.exteriorCleanliness.qualityService.comments"
              motifOptions={[
                {
                  value: 'Vitres sales',
                  label: 'Vitres sales',
                },
                {
                  value: 'Partie de rames sales : haut, bas, motrice',
                  label: 'Partie de rames sales : haut, bas, motrice',
                },
                {
                  value: 'Tags',
                  label: 'Tags',
                },
                {
                  value: 'Autres',
                  label: 'Autres',
                },
              ]}
            />
          ),
        },
      }}
      onChange={handleOnChange}
      validationSchema={Yup.object({
        serviceName: Yup.string().required('Ce champ est requis').nullable(),
      })}
    />
    </>
  );
};

export default NecForms;
